// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.product-price{display:flex;align-items:flex-start;flex-direction:column;justify-content:center}.product-price__label{font-size:var(--font-size--sm);font-weight:100;margin-right:var(--spacer-xs)}.product-price__row{display:flex;align-items:center}.product-price .sf-product-card__price{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
